














import { Vue, Component, Prop } from 'vue-property-decorator';

import MonthSlotGeneric from './MonthSlotGeneric.vue';
import CalendarAction from '../CalendarAction.vue';
import IconPlus from '@/components/icons/Plus.vue';

import { ISOCalendarDate } from '@/utils/date/types';

@Component({
    components: {
        MonthSlotGeneric,
        CalendarAction,
        IconPlus,
    },
})
export default class MonthSlotEmpty extends Vue {
    @Prop({ required: true }) date!: ISOCalendarDate
    @Prop({ default: true, type: Boolean }) hasActions!: boolean

    add() {
        this.$emit('edit:schedule')
    }

    get isShowActions() {
        return this.$route.name !== 'requests';
    }
}
